import {call, put} from 'redux-saga/effects';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {GetLiveAlertsCall} from "../../apis/live";
import {GET_LIVE_EVENTS_ERROR, GET_LIVE_ODDS_EVENTS_SUCCESS} from "../../constants/LiveConstants";

function* tryFunction() {
    const response: Record<string, string> = yield call(GetLiveAlertsCall);
    yield put({
        type: GET_LIVE_ODDS_EVENTS_SUCCESS,
        payload: response
    });
}


export function* getLiveOddsEventsSaga(): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction},
        failedType: GET_LIVE_EVENTS_ERROR
    };
    yield call(skeletonSaga, sagaPayload);
}
